import { useEffect, useState } from 'react'
import { Dependency, TemplateResponseData, ExtraData } from './types'
import * as jsonLogic from 'json-logic-js'

export type DependencyState = {
  isDisabled: boolean
  isHidden: boolean
  clearOnChange: string[]
}

export const useDependencies = (
  templateResponseData: TemplateResponseData,
  dependencies: Dependency[],
  extraData: ExtraData = null
) => {
  const [state, setState] = useState<DependencyState>({
    isDisabled: false,
    isHidden: false,
    clearOnChange: [],
  })

  useEffect(() => {
    /**
     * Note: this will run everytime that templateResponseData changes, maybe
     * there is something we can do to optimize it so it only runs when dependent
     * fields have changed?
     */
    if (dependencies && dependencies.length) {
      dependencies.forEach(dependency => {
        setState(currentState => ({
          ...currentState,
          [dependency.type]: jsonLogic.apply(dependency.value, {
            ...templateResponseData,
            EXTRA_DATA: extraData,
          }),
        }))
      })
    }
  }, [dependencies, templateResponseData, extraData])

  return state
}
